module.exports = __webpack_public_path__ + "static/media/purple_dogo.8a2e00e3.svg";